import { GuardedComponent } from '../components/guarded-component';
import { CreateProjectPage } from '../features/projects/create-project/create-project.page';
import { EditProjectPage } from '../features/projects/edit-project/edit-project.page';
import { ProjectDetailsPage } from '../features/projects/project-details/project-details.page';
import { ProjectsPage } from '../features/projects/projects.page';
import { UserPermissionName } from '../models/user-permission-name';

export const ProjectsRoute = {
  path: '/projects',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_PROJECT]} showPermissionError>
          <ProjectsPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'details/:projectID',
      name: 'Profile',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_PROJECT]} showPermissionError>
          <ProjectDetailsPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'create',
      name: 'New Project',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_PROJECT]} showPermissionError>
          <CreateProjectPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'details/:projectID/edit',
      name: 'Edit',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.EDIT_PROJECT]} showPermissionError>
          <EditProjectPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'create/:projectID',
      name: 'Create',
      element: (
        // <GuardedComponent requiredPermissions={[UserPermissionName.EDIT_PROJECT]} showPermissionError>
        <CreateProjectPage />
        // </GuardedComponent>
      ),
    },
    {
      path: 'edit/:projectID',
      name: 'Edit',
      element: (
        // <GuardedComponent requiredPermissions={[UserPermissionName.EDIT_PROJECT]} showPermissionError>
        <EditProjectPage />
        // </GuardedComponent>
      ),
    },
  ],
};
